import { gql } from "@apollo/client";

export const GET_PUBLIC_BACTERIOLOGICAL_MONITORING = gql`
  query GetPublicBacteriologicalMonitoring($systemId: Int!) {
    getPublicBacteriologicalMonitoring(systemId: $systemId) {
      systemId
      samplesRequired
      sampleType
      frequency
      scheduleBeginDate
      scheduleEndDate
      analyteName
    }
  }
`;

export const GET_DISINFECTION_BYPRODUCT_STAGE_2 = gql`
  query GetDisinfectionByProductStage2($systemId: Int!) {
    getPublicDisinfectionByProductStage2(systemId: $systemId) {
      systemId
      systemNumber
      sampleCount
      sampleType
      frequency
      scheduleGroupId
      sampleSite
      samplingDescription
      details {
        sampleId
        sampleIdCode
        site
        initBeginDate
        seasonalBeginMonth
        seasonalBeginDay
        seasonalEndMonth
        seasonalEndDay
        lastSampleDate
        nextSampleDateRange
        scheduleGroupId
      }
    }
  }
`;

export const GET_OTHER_DISTRIBUTION_MONITORING = gql`
  query GetPublicOtherDistributionMonitoring($systemId: Int!) {
    getPublicOtherDistributionMonitoringPbcu(systemId: $systemId) {
      systemId
      facilityId
      facilityCode
      sampleCount
      sampleType
      sampleFrequency
      analyteCode
      analyteName
      initBeginDate
      seasonalBeginMonth
      seasonalBeginDay
      seasonalEndMonth
      seasonalEndDay
      lastSampleDate
      nextSampleDateRange
    }
    getPublicOtherDistributionMonitoringAsbestos(systemId: $systemId) {
      systemId
      facilityId
      facilityCode
      sampleCount
      sampleType
      sampleFrequency
      analyteCode
      analyteName
      initBeginDate
      seasonalBeginMonth
      seasonalBeginDay
      seasonalEndMonth
      seasonalEndDay
      lastSampleDate
      nextSampleDateRange
    }
  }
`;

export const GET_CHLORINE_RESIDUAL_MONITORING = gql`
  query GetPublicChlorineResidualMonitoring($systemId: Int!) {
    getPublicChlorineResidualMonitoring(systemId: $systemId) {
      facilityCode
      facilityName
      samplesRequired
      sampleType
      sampleFrequency
    }
  }
`;

export const GET_MONITORING_REQUIREMENTS_BY_FACILITY = gql`
  query GetMonitoringRequirementsByFacility($systemId: Int!) {
    getMonitoringRequirementsByFacility(systemId: $systemId) {
      systemId
      facilityId
      facilityName
      facilityCode
      activityStatus
      facilityType
      details {
        facilityId
        anlytName
        anlytCode
        initBeginDate
        lastSampleDate
        seasonalBeginMonth
        seasonalEndMonth
        sampleCount
        sampleType
        frequency
        nextSampleDateRange
      }
    }
  }
`;

export const GET_OPEN_COMPLIANCE_SCHEDULES = gql`
  query GetOpenComplianceSchedules($systemId: Int!) {
    getOpenComplianceSchedules(systemId: $systemId) {
      scheduleTypeCode
      activityName
      description
      severity
      createdDate
      dueDate
    }
  }
`;
